import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import { Panel, PanelBody } from '../../components/panel/panel.jsx';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import KeywordDetailInfo from './keyword-detail-info';
import KeywordDetailAnswer from './keyword-detail-answer';
import KeywordDetailCard from './keyword-detail-card';

class KeywordDetail extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.keyword_id = Number(this.props.match.params.keywordId);

        this.state = {
            activeTab: '1',
        }

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-xl-6">
                    <KeywordDetailInfo keyword_id={this.keyword_id} onSave={() => {
                        if (this.keyword_id < 1) {
                            this.props.history.goBack();
                        }
                    }} />
                </div>
                {
                    this.keyword_id > 0 &&
                    <div className="col-xl-6">
                        <Panel>
                            <Nav tabs className="nav-tabs-inverse">
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
                                        <span className="d-none d-xs-inline">{strings.keyword_answer_list}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); }}>
                                        <span className="d-none d-xs-inline">{strings.keyword_card_list}</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <PanelBody>
                                {this.state.activeTab === "1" && (<KeywordDetailAnswer keyword_id={this.keyword_id} />)}
                                {this.state.activeTab === "2" && (<KeywordDetailCard keyword_id={this.keyword_id} />)}
                            </PanelBody>
                        </Panel>
                    </div>
                }
            </div>
        )
    }
}

export default KeywordDetail;